import { render } from "./UserImage.vue?vue&type=template&id=4c78fbdc&ts=true"
import script from "./UserImage.vue?vue&type=script&lang=ts"
export * from "./UserImage.vue?vue&type=script&lang=ts"

import "./UserImage.vue?vue&type=style&index=0&id=4c78fbdc&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__